import script from "./ExamResultSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamResultSummary.vue?vue&type=script&setup=true&lang=js"

import "./ExamResultSummary.vue?vue&type=style&index=0&id=e963b57a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e963b57a"]])

export default __exports__